export default __webpack_public_path__ + "images/140f39bb4b9c46d73bff5afb2b15069f.png";